
//Copyright (c) 2022 Panshak Solomon

import React from 'react'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import SnackbarProvider from 'react-simple-snackbar'
import Invoice from './components/Invoice/Invoice';
import Invoices from './components/Invoices/Invoices';
import InvoiceDetails from './components/InvoiceDetails/InvoiceDetails'
import NavBar from './components/NavBar/NavBar';
import Login from './components/Login/Login'
import Dashboard from './components/Dashboard/Dashboard';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import Settings from './components/Settings/Settings';
import Forgot from './components/Password/Forgot'
import Reset from './components/Password/Reset'
import ImportMensuel from './components/ImportMensuel/ImportMensuel'
import CampagneDetail from './components/ImportMensuel/CampagneDetail'
import AdminUsers from './components/Admin/AdminUsers'
import Coaches from './components/Coaches/Coaches'
import CoachDetail from './components/Coaches/CoachDetail'
import CorporateDashboard from './components/Corporate/CorporateDashboard'
import CorporateImport from './components/Corporate/CorporateImport'
import CorporateClients from './components/Corporate/CorporateClients'
import CorporateCampagneDetail from './components/Corporate/CorporateCampagneDetail'

function App() {

  const user = JSON.parse(localStorage.getItem('profile'))

  return (
    <div>
      <BrowserRouter>
      <SnackbarProvider>
     {user && <NavBar />} 
      <div className={user ? 'appShell' : undefined}>
      <Header />
        <Switch>
          <Route path="/" exact component={Login} />
          <Route path="/login" exact component={Login} />
          <Route path="/invoice" exact component={Invoice} />
          <Route path="/edit/invoice/:id" exact component={Invoice} />
          <Route path="/invoice/:id" exact component={InvoiceDetails} />
          <Route path="/invoices" exact component={Invoices} />
          <Route path="/coaches" exact component={Coaches} />
          <Route path="/coaches/:id" exact component={CoachDetail} />
          <Route path="/settings" exact component={Settings} />
          <Route path="/dashboard" exact component={Dashboard} />
          <Route path="/import" exact component={ImportMensuel} />
          <Route path="/campagnes/:id" exact component={CampagneDetail} />
          <Route path="/corporate/dashboard" exact component={CorporateDashboard} />
          <Route path="/corporate/import" exact component={CorporateImport} />
          <Route path="/corporate/clients" exact component={CorporateClients} />
          <Route path="/corporate/campagnes/:id" exact component={CorporateCampagneDetail} />
          <Route path="/admin/users" exact component={AdminUsers} />
          <Redirect exact from="/customers" to="/admin/users" />
          <Route path="/forgot" exact component={Forgot} />
          <Route path="/reset/:token" exact component={Reset} />
          <Redirect exact from="/new-invoice" to="/invoice" />

        </Switch>
        <Footer />
      </div>
        </SnackbarProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
